import React from "react";
import PostTagsTable from "../../../components/blog/tags/PostTagsTable";
import WrapperSection from "../../../components/global/WrapperSection";
import GlobalBreadcrumbs from "../../../components/global/GlobalBreadcrumbs";

const PostTagsList = () => {
    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <PostTagsTable />
        </WrapperSection>
    );
};

export default PostTagsList;
